export interface PagerItem { label: string; href: string; active: boolean }

const MAX_SIZE = 4;

export function pageHref(basePath: string, page: number): string {
	return page <= 1 ? `${basePath}.html` : `${basePath}/${page}/page.html`;
}

export function currentPage(query: any): number {
	return Math.max(1, parseInt(query?.page) || 1);
}

/** Port of base/Pagination/PaginationBase (rotate, ellipses, dot = false) */
export function buildPager(o: { basePath: string; page: number; total: number; pageSize: number }): PagerItem[] {
	const { basePath, total, pageSize } = o;
	const pageCount = Math.ceil(total / pageSize);
	if (!(pageCount > 1)) return [];

	const page = Math.min(Math.max(o.page, 1), pageCount);
	let pages: number[] = [];
	for (let i = 1; i <= pageCount; i++) pages.push(i);

	if (pageCount > MAX_SIZE) {
		let start = 0;
		let end = pageCount;
		const leftOffset = Math.floor(MAX_SIZE / 2);
		const rightOffset = MAX_SIZE % 2 === 0 ? leftOffset - 1 : leftOffset;
		if (page <= leftOffset) {
			end = MAX_SIZE;
		} else if (pageCount - page < leftOffset) {
			start = pageCount - MAX_SIZE;
		} else {
			start = page - leftOffset - 1;
			end = page + rightOffset;
		}
		pages = pages.slice(start, end);
		if (start > 0) pages.unshift(1);
		if (end < pageCount) pages.push(pageCount);
	}

	return pages.map((n) => ({ label: String(n), href: pageHref(basePath, n), active: n === o.page }));
}
